module.exports = __webpack_public_path__ + "static/media/pauseButton.3ceca52b.png";